function hasAppliedQB(store) {
    if (!store) return false;

    const items = store instanceof Map
        ? Array.from(store.values())
        : Array.isArray(store)
            ? store
            : Object.values(store);

    const firstQBItem = items.find(item => item?.appliedQB);
    if (firstQBItem) {
        return true;
    }
    return false;
}

function hideShopifyDiscount() {
    const discounts = document.querySelectorAll(".discounts.list-unstyled");

    if (!discounts.length) return false;

    discounts.forEach(el => {
        el.style.setProperty("display", "none", "important");
    });

    return true;
}

const interval = setInterval(() => {
    const store = BSS_B2B?.storage?.cartStorage?.store;

    if (hasAppliedQB(store)) {
        if (hideShopifyDiscount()) {
            clearInterval(interval);
        }
    }

    if (++tries >= MAX_TRIES) {
        clearInterval(interval);
    }
}, 100);
